<!-- 编辑时间组件 -->
<template>
    <div class="DurationEdit">
      <div class="DurationInput">
        <input type="text" v-model="DurationMessage.hour" @input="verifyNumber('hour')">
        <span>h</span>
      </div>
      <div class="DurationInput">
        <input type="text" v-model="DurationMessage.min" @input="verifyNumber('min')">
        <span>m</span>
      </div>
      <div class="DurationInput">
        <input type="text" v-model="DurationMessage.second" @input="verifyNumber('second')">
        <span>s</span>
      </div>
      <div class="Durationclose" @click="EditEnd('close')">
        <i class="iconfont icon-cuo"></i>
      </div>
      <div class="Durationsave" @click="EditEnd('end')">
        <i class="iconfont icon-duihao"></i>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    // 子事件Duration
    SonEventDuration: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      DurationMessage: {
        hour: 0,
        min: 0,
        second: 0
      }
    }
  },
  created () {
  },
  mounted () {

  },
  watch: {
    SonEventDuration: {
      handler (value) {
        this.calculateInterval(value)
      },
      immediate: true
    }
  },
  methods: {
    // 编辑结束
    EditEnd (type) {
      const hour = Number(this.DurationMessage.hour)
      const min = Number(this.DurationMessage.min)
      const second = Number(this.DurationMessage.second)
      const duration = (hour * 60 * 60 + min * 60 + second) * 1000
      this.$emit('EditEnd', {
        type,
        duration
      })
    },
    // 时间校验
    verifyNumber (key) {
      this.DurationMessage[key] = this.DurationMessage[key].replace(/[^\d]/g, '')
      if (this.DurationMessage[key] != '') {
        this.DurationMessage[key] = Number(this.DurationMessage[key])
      }
      const DurationValue = this.DurationMessage[key]
      if (key == 'hour') {
        this.DurationMessage[key] = DurationValue > 23 ? 23 : DurationValue
      } else {
        this.DurationMessage[key] = DurationValue > 59 ? 59 : DurationValue
      }
    },
    // 计算分秒小时
    calculateInterval (time) {
      if (typeof time == 'number') {
        let hour = Math.floor(time / (60 * 60 * 1000))
        let min = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
        let second = Math.floor((time % (60 * 1000)) / 1000)
        hour = hour || 0
        min = min || 0
        second = second || 0
        this.DurationMessage = {
          hour,
          min,
          second
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.DurationEdit{
  position: absolute;
  top: 38px;
  right: 0px;
  display: flex;
  align-items: center;
  padding: 12px;
  width: 288px;
  height: 56px;
  background: #1A1A1A;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  z-index: 3;
  .DurationInput{
    position: relative;
    margin-right: 8px;
    input{
      width: 64px;
      height: 32px;
      outline: none;
      background: #444444;
      border: none;
      color: #dbdbdb;
      padding-left: 8px;
      padding-right: 25px;
      border-radius: 4px;
      line-height: 32px;
      font-size: 14px;
    }
    span {
      position: absolute;
      top: 5px;
      right: 7px;
      color: #666666;
    }
  }
  .Durationclose{
    color: #DBDBDB;
    margin: 0 11px;
    i {
      font-size: 12px;
    }
  }
  .Durationsave{
    color: #33AB4F;
    i {
      font-size: 12px;
    }
  }
}

</style>
